const APP_ROUTES = {
    LOGIN: "/",
    LOGIN1: "/login",
    DASHBOARD: "/dashboard",
    PROFILESCREEN: '/profile',
    ENQLIST: "/enqList",
    APPROVEENQ: "/patientReferralConfirmationUrl",
    SERVICE: "/serviceList",
    FILTERENQ: "/filterEnquiry",
    DASHENQ: "/dashEnquiry",
    FINANCE: '/billingConformationApproval',
    PRALIST: '/practiceAdminList',
    BILLAPPROVE: '/billingApproval',
    DOWNLOAD: '/download',
    AGENT_REPORTS: "/agent-reports",
    TRAUMA: '/traumaSurgeryEnquiryConfirmationRequest',
    FEEDP: '/patientFeedBack',
    FEEDREPORT: '/patientFeedBackReport'








}
export { APP_ROUTES } 